function showCode(container, collapsible) {

    var button  = container.find('._js-show-code-button'),
        showCodeBody = container.find('.show-code__body');

    container.find('.show-code').each(function(){
        if (!$(this).hasClass('_expanded')) {
            $(this).find('.show-code__body').hide();
        }
    });

    button.on('click', function(){

        var showCode = $(this).parents('.show-code'),
            showText = $(this).attr('data-show'),
            hideText = $(this).attr('data-hide');

        if ( !showCode.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.show-code').removeClass('_expanded');
                showCodeBody.stop().slideUp(300);
            }
            showCode.addClass('_expanded');
            $(this).text(hideText);
            showCode.find('.show-code__body').stop().slideDown(300);
        } else {
            showCode.removeClass('_expanded');
            $(this).text(showText);
            showCode.find('.show-code__body').stop().slideUp(300);
        }
    });
}